import { DropzoneFullScreenProtected } from '@components'

import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../enums/scope'
import {
  IMPORTED_INVOICE_ACCEPTED_FORMATS,
  IMPORTED_INVOICE_MAX_SIZE_IN_BYTES,
} from '../../constants/importedInvoicesUpload'
import { useImportedInvoicesUploadContext } from '../../context/ImportedInvoicesUploadContext'

export const ImportedInvoicesDropzone = (): ReactElement => {
  const { t } = useTranslation()
  const { isUploadBlocked, isUploading, progress, uploadFiles } = useImportedInvoicesUploadContext()

  return (
    <DropzoneFullScreenProtected
      accept={IMPORTED_INVOICE_ACCEPTED_FORMATS}
      blockedText={t('imported_invoices.upload.dropzone_blocked')}
      forceActive={isUploading}
      isBlocked={isUploadBlocked}
      isUploading={isUploading}
      maxSize={IMPORTED_INVOICE_MAX_SIZE_IN_BYTES}
      onDrop={uploadFiles}
      scopes={Scope.UploadsWrite}
      uploadingText={t('ds.dropzone.uploading_with_counter', {
        current: progress.current,
        total: progress.total,
      })}
    />
  )
}
